import React from 'react';
import { ChatProvider } from './ChatProvider';
import { AuthProvider } from './AuthContext';
import ChatWindows from './ChatWindows';
import "./styles/tailwindChat.css"
import "./global"
export function Workchat(props) {
    return (
        <div className="workchat">
            <AuthProvider>
                <ChatProvider>
                    <ChatWindows {...props} />
                </ChatProvider>
            </AuthProvider>
        </div>
    );
}

